import IApartment from "../types/apartment-type";
import api from "./auth-interceptor"

class ApartmentService {
  getAllApartments() {
    return api.get(`apartments/`);
  }

  listApartment(apartmentContent: IApartment) {
    return api.post(`apartments/`, apartmentContent);
  }

  getInfoById(listingId: string) {
    return api.get<IApartment>(`apartments/${listingId}`);
  }

  updateApartment(apartmentId: string, apartmentContent: IApartment) {
    return api.put(`apartments/${apartmentId}`, apartmentContent);
  }

  deleteListing(apartmentId: string) {
    return api.delete(`apartments/${apartmentId}/`);
  }
}

const apartmentService = new ApartmentService();
export default apartmentService;
